import styled from 'styled-components';

interface IHeading {
  level: number;
}

const Heading = styled.h1<IHeading>`
  font-style: italic;
  font-weight: 700;
  font-size: ${props => {
    switch (props.level) {
      case 1:
        return '35px';
      case 2:
        return '20px';
      default:
        return '35px';
    }
  }};

  @media (min-width: 768px) {
    font-size: ${props => {
      switch (props.level) {
        case 1:
          return '60px';
        case 2:
          return '30px';
        default:
          return '60px';
      }
    }};
  }
`;

export default Heading;
